
import React from 'react';

import OrderEdit from 'components/Order/Edit';


export default function PlanningEdit(props) {
  return (
    <OrderEdit
      {...props}
      apiUrl={'planning'}
      basePath={'/planning'}
    />
  );
}
